import React from 'react';
import cartApi from '../../store/cartApi.js'
import { storePubSub } from '../../store/applications/consts.js';
import { utils, TranslationUtil } from '../../utils'

class FullscreenCheckoutLink extends React.Component {

  render() {
    const cartItems = this.props.cartItems || [];
    let renderComponent = null;
    const cartItemsCount = cartItems.length;
    if (cartItemsCount) {
      const linkText = TranslationUtil.getByKey('Gallery_ArtStore_UOU_Continue_Checkout_Label') + ` (${cartItemsCount})`;

      renderComponent = (<button
        className='checkout-link'
        onClick={this.props.onClick}
        tabIndex={utils.getTabIndex('fullscreenCheckout')}
        aria-label={linkText}
      >
        {linkText}
      </button>);
    }

    return renderComponent;
  }
}

export default FullscreenCheckoutLink;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenCheckoutLink.js